import { render } from "./dlth-basic.vue?vue&type=template&id=427c32e9&scoped=true"
import script from "./dlth-basic.vue?vue&type=script&lang=js"
export * from "./dlth-basic.vue?vue&type=script&lang=js"

import "./dlth-basic.vue?vue&type=style&index=0&id=427c32e9&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c32e9"]])

export default __exports__